var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.2539C15.5 12.4166 15.443 12.5795 15.3291 12.7038L9.49578 19.0674C9.26784 19.3161 8.89874 19.3161 8.67095 19.0674C8.44316 18.8188 8.44302 18.4161 8.67095 18.1676L14.0918 12.2539L8.67095 6.34016C8.44302 6.0915 8.44302 5.68884 8.67095 5.44034C8.89889 5.19184 9.26799 5.19168 9.49578 5.44034L15.3291 11.804C15.443 11.9282 15.5 12.0911 15.5 12.2539Z",
    fill: "#146C94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowBlue);
export default __webpack_public_path__ + "static/media/right-arrow-blue.28ca61f3e2c956ff37fdd093abad3e75.svg";
export { ForwardRef as ReactComponent };